export const DAIMLER_CLARA_VEHINFO = 'DAIMLER_CLARA_VEHINFO';
